import React, { FC, HTMLAttributes } from 'react';
import Container from '../../../../Common/Container/Container';
import * as classes from './Section.module.scss';
import cn from 'classnames';

interface Props extends HTMLAttributes<HTMLElement> {
  number: string;
  label: string;
}

const Section: FC<Props> = ({ children, label, number, ...rest }) => {
  return (
    <section className={cn(classes.wrapper, rest.className)} data-aos='fade-in'>
      <Container className={classes.header}>
        <div className='row'>
          <div className='col-lg-5 col-md-6 col-sm-5 col-2'>{number}</div>
          <div className='col-lg-7 col-md-6 col-sm-7 col-10'>{label}</div>
        </div>
      </Container>
      {children}
    </section>
  );
};

export default Section;
